import { WindowLocation } from '@reach/router';

import { useRedirectQuery } from './redirectQuery';

// if Cogsworth was used to schedule an appointment, we get a redirect
// back from the BE cogsworth demuxer with search params relaying the id
// of the Cogsworth appointment and the service for which it was booked.
// This type describes the data sent back, once deserialized.
export interface IBookedAppointmentInfo {
	id: string;
	folxService: string;
	rescheduled?: boolean;
}

function normalizeCogsworthId(info: IBookedAppointmentInfo): IBookedAppointmentInfo {
	return { ...info, id: info.id.replaceAll(/[\W_]/g, '') };
}

export function useCogsworthBookingRedirect(
	location: WindowLocation
): IBookedAppointmentInfo | undefined {
	const query = useRedirectQuery(location);
	return query
		? // Parse each query value as a JSON string
		  normalizeCogsworthId(
				Object.fromEntries(
					Object.entries(query).map(([key, value]) => [key, JSON.parse(value as string)])
				) as IBookedAppointmentInfo
		  )
		: undefined;
}
